"use client";

import { useEffect } from "react";
import {
  useWebInfoDetail,
  useWebInfoSave,
} from "../../../hooks/api/web-info/hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import toast from "react-hot-toast";
import { Form, Input, Button } from "antd";
import UploadFoodImage from "../../../lib/UploadFoodImage";

// ---------------- Validation ----------------
const schema = yup.object({
  description: yup.string().required("Description is required"),
  logo: yup.string().required("Logo is required"),
});

type FooterFormType = yup.InferType<typeof schema>;

const FooterForm = () => {
  const { data: details } = useWebInfoDetail("FOOTER");

  const { mutate: saveForm, isPending } = useWebInfoSave({
    onSuccess: () => toast.success("Saved successfully"),
    onError: (error: any) =>
      toast.error(error?.message || "Something went wrong"),
  });

  const { control, handleSubmit, reset , watch ,formState : {errors}} = useForm<FooterFormType>({
    resolver: yupResolver(schema),
    defaultValues: {
      description: "",
      logo: "",
    },
  });


  // ---------------- Prefill (Edit mode) ----------------
  useEffect(() => {
    if (details?.data) {
      reset({
        description: details.data.description || "",
        logo: details.data.logo || ""
      })
    }
  }, [details?.data]);

  // ---------------- Submit ----------------
  const onSubmit = (values: FooterFormType) => {
    saveForm({
       ...(details?.data?._id && { _id: details.data._id }),
      type: "FOOTER",
      description: values.description,
      logo : values.logo
    });
  };

  return (
    <div className="w-full mx-auto p-6 bg-[#fdf0e3] rounded-xl border border-blue-300">
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        
        {/* DESCRIPTION */}
        <Form.Item label="Description" required>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <Input.TextArea {...field} placeholder="Enter footer description" />
            )}
          />
        </Form.Item>

        {/* LOGO UPLOAD */}
        <Form.Item label="Logo" required>
          <Controller
            name="logo"
            control={control}
            render={({ field }) => (
              <UploadFoodImage
                maxUploadCount={1}
                value={field.value}
                onChange={(files) => field.onChange(files)}
              />
            )}
          />
        </Form.Item>

        {/* BUTTON */}
        <div className="mt-6 flex justify-start">
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            className="bg-orange-500 hover:bg-orange-600"
          >
            {isPending ? "Saving..." : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FooterForm;
